export default {
  component: {
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0px',
    '@media (max-width: 640px)': {
      width: '100%',
      display: 'block',
    },
  },
};
